import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './LandingPageResult.css';
const plantillas = [
  'https://hihaho.s3.us-east-1.amazonaws.com/plantilla1.png',
  'https://hihaho.s3.us-east-1.amazonaws.com/plantilla2.png',

];

const LandingPageResult: React.FC = () => {
  
  const history = useHistory();
  const [landingData, setLandingData] = useState<any>(null);
  const [selectedTemplate, setSelectedTemplate] = useState<number | null>(1); // Inicializado a 1 para mostrar la primera plantilla

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('landingData') || '{}');
    setLandingData(data);
  }, []);

  const handleTemplateSelect = (templateNumber: number) => {
    setSelectedTemplate(templateNumber);
  };

  const handleSelectFinal = () => {
    if (selectedTemplate) {
      localStorage.setItem('selectedTemplate', selectedTemplate.toString());
      history.push('/LandingEdition');
    }
  };

  return (
    <div className="landing-page-result-wrapper">
      {/* Header */}
      <div className="landing-page-result__header">
        <h1 className="landing-page-result__title">Crea tu Landing</h1>
        <p className="landing-page-result__subtitle">Para tu Negocio</p>
        <div className="landing-page-result__underline"></div>
      </div>

      
      <div className="template-container">
        {/* Sidebar Options */}
        <div className="template-options-container">
          <div 
            className={`template-option ${selectedTemplate === 1 ? 'selected' : ''}`}
            onClick={() => handleTemplateSelect(1)}
          >
            <img 
              src={plantillas[0]}
              alt="Plantilla 1" 
              className="template-thumbnail"
            />
            <span className="template-label">A</span>
          </div>
          
          <div 
            className={`template-option ${selectedTemplate === 2 ? 'selected' : ''}`}
            onClick={() => handleTemplateSelect(2)}
          >
            <img 
              src={plantillas[1]}
              alt="Plantilla 2" 
              className="template-thumbnail"
            />
            <span className="template-label">B</span>
          </div>
        </div>

        {/* Main Preview */}
        <div className="modal-template">
        
          <div className="modal-content-template">
            <iframe 
              src={`/Plantillas/Plantilla${selectedTemplate}/index.html`}
              title={`Plantilla ${selectedTemplate}`}
              className="modal-template-preview"
            />
          </div>
        </div>
      </div>

      <button 
        className="select-template-button"
        onClick={handleSelectFinal}
      >
        ▶ Seleccionar Plantilla
      </button>

    
    </div>
  );
};

export default LandingPageResult;